<template>
    <el-col id="colizquierda" :xs="24" :md="12" :cols="12">
        <div class="instrucciones"
            :style="`background-color: ${working == 'firmas' ? 'rgba(254, 211, 48, 0.39)' : '#0984e333'};`">
            <div class="instrucciones-msg">
                <div class="contenedorContador">
                    <h1 :style="`color: ${working == 'firmas' ? '#e6a23c' : '#0984e3'}; font-weight: revert;`">{{ hora }}
                    </h1>
                    <div v-if="datosemp.saludo"
                        style="display: flex; text-align: left; align-items: center; justify-content:space-between; background: rgba(0, 0, 0, 0.26); padding: 10px; border-radius: 10px; color: white; transition: 0.5s; margin-bottom: 10px; min-width: 300px; height: 77px;">
                        <span style="display: flex; align-items:center;">
                            <img v-if="working == 'documentos'"
                                :style="`border-radius: 50%; position:absolute; transition: 1s;`"
                                :src="`https://www.gravatar.com/avatar/${datosemp.email}?d=https://cdn-icons-png.flaticon.com/512/403/403554.png?w=740&t=st=1689841343~exp=1689841943~hmac=c6cc07fa541b994409e820351829b5766ab2d175e6a73c5e1357f2c2004d250a`"
                                width="50px" />
                            <img v-if="working == 'firmas'"
                                :style="`border-radius: 50%; position:absolute; transition: 1s;`"
                                :src="`https://www.gravatar.com/avatar/${datosemp.email}?d=https://i.imgur.com/KPPTsiB.png`"
                                width="50px" />
                            <div style="display:flex; flex-direction: column; margin-left: 60px;">
                                <p style="margin: 0px; font-weight: 400; font-size: 1.3rem; margin-bottom: 5px;">
                                    {{ datosemp.saludo }}
                                </p>
                            </div>
                        </span>
                    </div>
                    <el-collapse-transition>
                        <div
                            style="display: flex; text-align: left; align-items: center; justify-content: center; background: rgba(0, 0, 0, 0.26); padding: 10px; border-radius: 10px; color: white; transition: 0.5s; margin-bottom: 10px; min-width: 300px;">
                            <span
                                style="font-size: 4rem; margin-right: 10px; display:flex; flex-direction: column; align-items: center;"><b>
                                    {{ obtener('dia') }} </b><b style="font-size: 1.5rem;"></b></span>
                            <span style="display:flex; flex-direction: column; justify-content:center;">
                                <span style="margin: 5px;"><b> {{ obtener('diasem').charAt(0).toUpperCase() +
                                    obtener('diasem').slice(1) }} </b></span>
                                <span style="margin: 5px;"> {{ obtener('mes').charAt(0).toUpperCase() +
                                    obtener('mes').slice(1) }}
                                </span>
                            </span>
                        </div>
                    </el-collapse-transition>
                    <el-collapse-transition v-if="datosemp.token && working == 'firmas'">
                        <div
                            style="display: flex; text-align: left; align-items: center; justify-content: center; background: rgba(0, 0, 0, 0.26); padding: 10px; border-radius: 10px; color: white; transition: 0.5s; margin-bottom: 10px; min-width: 300px;">
                            <el-button @click="$router.push('/agenda')" size="large" type="warning"><el-icon><Notebook /></el-icon> Agenda</el-button>
                            <el-button @click="$router.push('/panel-firmas')" size="large" type="warning"><el-icon><Notification /></el-icon> Panel</el-button>
                        </div>
                    </el-collapse-transition>
                    <!-- <el-collapse-transition>
                        <div
                            style="display: flex; flex-direction: column; text-align: left; align-items: flex-start; background: rgba(0, 0, 0, 0.26); padding: 10px; border-radius: 10px; color: white; transition: 0.5s; margin-bottom: 10px; min-width: 300px;">
                            <span style="text-align: left;"><font-awesome-icon :icon="['fas', 'circle-exclamation']"
                                    fade /> Nóminas pendientes de revisar</span>
                            <span style="text-align: left;"><font-awesome-icon :icon="['fas', 'circle-exclamation']"
                                    fade /> Documentos pendientes de leer</span>
                            <span style="text-align: left;"><font-awesome-icon :icon="['fas', 'circle-exclamation']"
                                    fade /> Documentos pendientes de firmar</span>
                        </div>
                    </el-collapse-transition> -->
                </div>
            </div><img v-if="working == 'documentos'" id="logoempresa" src="@/assets/work.png">
            <img v-if="working == 'firmas'" id="logoempresa" src="@/assets/work_2.png">
        </div>
    </el-col>
</template>

<script>
import dayjs from 'dayjs'
require('dayjs/locale/es')
dayjs.locale('es');
import { mapState } from 'vuex'
export default {
    name: 'ColumnaIzquierda',
    data() {
        return {
            hora: '10:05',
            working: process.env.VUE_APP_WORKING,
        }
    },
    mounted() {
        this.hora = this.obtener('hora');
        this.interval = setInterval(() => {
            this.hora = this.obtener('hora');
        }, 1000);
    },
    computed: mapState([
        'datosemp'
    ]),
    methods: {
        obtener(tipo) {
            switch (tipo) {
                case 'dia':
                    return dayjs().format('D');
                case 'diasem':
                    return dayjs().format('dddd');
                case 'mes':
                    return dayjs().format('MMMM');
                case 'hora':
                    return dayjs().format('H:mm');
            }
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#colizquierda {
    position: relative;
    background-size: cover;
    display: flex;
    overflow: hidden;
    padding-left: 0px !important;
    padding-right: 0px !important;

    .instrucciones {
        color: #33438a;
        width: -webkit-fill-available;
        text-align: right;
        padding-bottom: 20px;
        transition: 2s;
        display: flex;
        flex-direction: column;

        h1 {
            font-size: 2rem;
            margin: 20px;
            transition: 0.5s;

            @media(min-width: 990px) {
                font-size: 4rem;
            }
        }

        .instrucciones-msg {
            display: flex;
            flex-flow: column;
            align-items: flex-end;
            margin: auto;
            position: absolute;
            height: 100vh;
            width: 100%;
            justify-content: center;
        }

        .contenedorContador {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            justify-content: center;
            z-index: 1;

            @media (max-width: 990px) {
                display: none;
            }
        }
    }

    #logoempresa {
        display: none;
        position: absolute;
        max-width: 40%;
        max-height: 150px;
        left: 20px;
        bottom: 20px;
        transition: 1s;

        @media(min-width: 991px) {
            display: block;
        }
    }

    @media (min-width:990px) {
        height: 100vh;
    }

    @media(max-width: 990px) {
        display: none;
    }
}</style>